import { LoadersType } from '@modules/builders';

import { DataElementType } from '@containers/OperationBlock/types';

import { asyncActions } from './actions';

export interface OperationBlockStateType {
  loaders: LoadersType<typeof asyncActions>;
  errors: {
    data?: Record<string, string>;
    message?: string;
  };
  paymentSelect: {
    left?: {
      group: DataElementType['group'];
      value: DataElementType['value'];
    };
    right?: {
      group: DataElementType['group'];
      value: DataElementType['value'];
    };
  };
  consentRequired?: 'zh' | 'us';
}

export const initialState: OperationBlockStateType = {
  loaders: {},
  errors: {},
  paymentSelect: {},
};

export default initialState;
